import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var TrophyIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M10.152 1.15h2.795c.748 0 1.38 0 1.89.058.538.061 1.045.196 1.489.54.189.147.359.316.505.505.192.248.32.515.404.797h.967a2.75 2.75 0 012.75 2.75v1.67a3.93 3.93 0 01-3.757 3.926 3.605 3.605 0 01-.303.726c-.668 1.28-2.073 3.132-4.492 3.491v1.212h2.687a2.845 2.845 0 012.845 2.845 2.18 2.18 0 01-2.18 2.18H7.347a2.18 2.18 0 01-2.18-2.18 2.845 2.845 0 012.845-2.845H10.7v-1.2c-1.234-.15-2.207-.627-2.956-1.263-.897-.762-1.433-1.72-1.747-2.517a3.589 3.589 0 01-.152-.452A3.93 3.93 0 012.15 7.469V5.8A2.75 2.75 0 014.9 3.05h.964c.086-.28.212-.548.404-.796a2.85 2.85 0 01.506-.505c.443-.344.951-.479 1.49-.54.51-.058 1.141-.058 1.889-.058zM5.67 5.632v4.03A2.231 2.231 0 013.85 7.47V5.8c0-.579.47-1.05 1.05-1.05h.775c-.005.274-.005.568-.005.883zm11.76 4.03a2.231 2.231 0 001.822-2.193V5.8c0-.579-.47-1.05-1.05-1.05h-.777c.004.274.004.568.004.883v4.03zM8.454 2.898c-.385.044-.542.119-.64.194a1.15 1.15 0 00-.203.204c-.076.097-.15.255-.195.64-.045.402-.047.937-.047 1.745v4.125c0 .406.002.546.04.783a3.197 3.197 0 00.102.451c.015.05.031.091.067.184.248.629.646 1.317 1.266 1.844.604.513 1.459.908 2.705.908 1.993 0 3.2-1.424 3.836-2.64a2.64 2.64 0 00.111-.228c.026-.063.058-.154.11-.334.012-.042.05-.194.058-.236.062-.304.064-.475.064-.975V5.68c0-.808-.001-1.343-.047-1.745-.044-.385-.119-.543-.194-.64a1.15 1.15 0 00-.204-.204c-.097-.075-.254-.15-.64-.194-.402-.046-.937-.047-1.745-.047H10.2c-.808 0-1.342.001-1.745.047zm-.443 15.628c-.632 0-1.145.513-1.145 1.145 0 .265.215.48.48.48h8.405a.48.48 0 00.48-.48c0-.632-.512-1.145-1.145-1.145H8.012z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
TrophyIcon.isCarinaIcon = true;
export default TrophyIcon;
